<div class="modal-header">
  <div>
    <h4 class="modal-title">
      {{ "updateAvailability.displayAvailability.title" | translate }}
    </h4>
    <h5 class="m-b-0 m-t-10">
      {{ companyName }}
    </h5>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <b>{{ companyName }}</b>
  {{ "updateAvailability.displayAvailability.available" | translate }}
  <li *ngFor="let date of dates">
    {{ "campaignDetails.availability.from" | translate }}
    <b>{{ date.startDate | localizedDate }}</b>
    {{ "campaignDetails.availability.to" | translate }}
    <b>{{ date.endDate | localizedDate }}</b>
  </li>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    data-bs-dismiss="modal"
    (click)="close()"
  >
    {{ "buttons.close" | translate }}
  </button>
</div>
